import { LayoutDashboard } from 'lucide-react'

import type { GisTab } from '../../../api/types'

export type DashboardBoard = 'issues' | 'coverage'

interface DashboardButtonProps {
  /** The active tab — the button IS that tab's dashboard trigger (hidden elsewhere). */
  tab: GisTab
  /** Open the active board's dashboard window. */
  onOpen: (board: DashboardBoard) => void
}

/**
 * Tab-bar "Dashboard" button (sits next to the period control), interconnected with the active tab:
 * on the Issues tab it pops the Issues dashboard, on the Coverage tab the Coverage dashboard — one
 * press, no menu. Hidden on the Dashboard tab itself (that tab already IS the combined dashboard).
 * Styled to match `PeriodDropdown` so the right cluster reads as one strip of peers.
 */
export function DashboardButton({ tab, onOpen }: DashboardButtonProps) {
  if (tab !== 'issues' && tab !== 'coverage') {
    return null
  }
  const boardLabel = tab === 'issues' ? 'Issues' : 'Coverage'
  return (
    <button
      type="button"
      onClick={() => onOpen(tab)}
      title={`Open the ${boardLabel} dashboard`}
      className="flex h-[30px] items-center gap-[6px] rounded-[9px] border border-gis-line bg-white px-[10px] text-[12px] font-medium text-gis-ink-2 transition-colors hover:border-[#c7d2ea] hover:bg-[#fbfcfe] focus-visible:ring-2 focus-visible:ring-blue-500/60"
    >
      <LayoutDashboard className="h-[13px] w-[13px] text-gis-muted" aria-hidden />
      Dashboard
    </button>
  )
}
